const urls = {
  base: '/viewer/',

  fiscalYears: '',
  fiscalYearExperiments: ':year',
  experimentRoot: ':year/:ex_id',
  folderContents: ':year/:ex_id/:f_id',

  fileInformation: '/detail',
}

export function fiscalYearsUrl(): string {
  return urls.base + urls.fiscalYears;
}

export function fiscalYearExperimentsUrlTemplate(): string {
  return urls.base + urls.fiscalYearExperiments;
}

export function fiscalYearExperimentsUrl(year: number): string {
  return fiscalYearExperimentsUrlTemplate().replace(':year', year.toString());
}

export function experimentRootUrlTemplate(): string {
  return urls.base + urls.experimentRoot;
}

export function experimentRootUrl(year: number, ex_id: number): string {
  return experimentRootUrlTemplate().replace(':year', year.toString()).replace(':ex_id', ex_id.toString());
}

export function folderContentsUrlTemplate(): string {
  return urls.base + urls.folderContents;
}

export function folderContentsUrl(year: string, ex_id: string, f_id: string): string {
  return folderContentsUrlTemplate().replace(':year', year).replace(':ex_id', ex_id).replace(':f_id', f_id);
}

export function fileInformationUrlTemplate(): string {
  return urls.base + urls.folderContents + urls.fileInformation;
}

export function fileInformationUrl(year: string, ex_id: string, f_id: string): string {
  return fileInformationUrlTemplate().replace(':year', year).replace(':ex_id', ex_id).replace(':f_id', f_id);
}

export function retrieveExperimentListUrl(): string {
  return 'api/asebi/fileinfos/retrieveExperimentList/';
}

export function retrieveSizeLimitUrl(): string {
  return 'api/asebi/fileinfos/retrieveSizeLimit';
}

export function downloadUrl(contents_info: number[]): string {
  return "/api/asebi/fileinfos/download?id=" + contents_info.join(',');
  // 2023.12.15 URL連結処理の際に、downloadUrl()だけは冒頭に"/"が必要。 "/"がない場合は、ファイルダウンロードをしようとすると白画面になる。
}

export function checkTotalSizeUrl(contents_info: number[]): string {
  return "api/asebi/fileinfos/checkTotalSize?id=" + contents_info.join(',');
}

export default urls;
